import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'
import HomeView from '../views/HomeView.vue'

const languages = ['en', 'fr', 'es', 'ru', 'ar', 'zh']; // Список разрешенных языков
const languagePattern = languages.join('|'); // Создаем паттерн для разрешенных языков

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:locale?',
    name: 'home',
    component: HomeView
  },
  {
    path: '/article/:id/:locale?',
    name: 'article',
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ArticleView.vue')
  },
  {
    path: '/article/:locale?',
    name: 'article',
    component: () => import(/* webpackChunkName: "about" */ '../views/ArticleView.vue')
  },
  {
    path: '/scoring/:locale?',
    name: 'scoring',
    component: () => import(/* webpackChunkName: "about" */ '../views/ScoringView.vue')
  },
  {
    path: '/nominees2/:locale?',
    name: 'nominees2',
    component: () => import(/* webpackChunkName: "about" */ '../views/NomineesView2.vue')
  },
  {
    path: '/vote/:locale/:slug',
    name: 'vote',
    component: () => import(/* webpackChunkName: "about" */ '../views/VotePage.vue'),
  },
  {
    path: '/privacy/:locale?',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "about" */ '../views/PrivacyPolitics.vue')
  },
  {
    path: '/terms/:locale?',
    name: 'terms',
    component: () => import(/* webpackChunkName: "about" */ '../views/TermsCondition.vue')
  },
  {
    path: '/about/:locale?', // Страница "О нас" с параметром языка
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutSite.vue')
  },
  {
    path: '/winner/:locale?', // Страница "О нас" с параметром языка
    name: 'winner',
    component: () => import(/* webpackChunkName: "about" */ '../views/WinnerView.vue')
  },
  {
    path: '/metodics/:locale?',
    name: 'metodics',
    component: () => import(/* webpackChunkName: "about" */ '../views/MetodicsPage.vue')
  },
  {
    path: '/contact/:locale?',
    name: 'contact',
    component: () => import(/* webpackChunkName: "about" */ '../views/ContactPage.vue')
  },
  {
    path: '/thanks/:locale?',
    name: 'thanks',
    component: () => import(/* webpackChunkName: "about" */ '../views/ThanksSite.vue')
  },
  {
    path: '/add/:locale?',
    name: 'add',
    component: () => import(/* webpackChunkName: "about" */ '../views/AddCorporation.vue')
  },
  {
    // Добавляем роут для перенаправления на главную страницу при несуществующем пути
    path: '/:pathMatch(.*)', // Ловим все несуществующие пути
    redirect: '/', // Перенаправляем на главную страницу
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

router.afterEach(() => {
  if (typeof (window as any).ym === 'function') {
    (window as any).ym(110715365, 'hit', window.location.href)
  }
})

export default router
